
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.86 24.03c-3.378-5.94-1.374-13.534 4.476-16.963.386-.227.778-.429 1.176-.608a18.792 18.792 0 002.246 12.144c2.46 4.326 6.372 7.27 10.747 8.567-.588.52-1.235.992-1.938 1.404-5.85 3.43-13.33 1.394-16.708-4.545zm3.117-19.353c-7.15 4.19-9.6 13.473-5.472 20.732 4.128 7.259 13.271 9.746 20.421 5.555a14.977 14.977 0 004.282-3.764c.644-.832.164-2.06-.867-2.216-4.55-.693-8.752-3.405-11.23-7.76a16.031 16.031 0 01-1.447-12.45c.297-1.016-.597-1.978-1.612-1.737-1.398.332-2.77.875-4.075 1.64z","fill":"#0ABEC3"}})])
          )
        }
      }
    